import BaseIcon from './base-icon';

class MapsIcon extends BaseIcon {
  renderSVG(): string {
    return `
      <svg
        class="map-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M12 2C8.686 2 6 4.686 6 8c0 4.26 6 13 6 13s6-8.74 6-13c0-3.314-2.686-6-6-6z" />
        <circle cx="12" cy="8" r="2" />
      </svg>
    `;
  }
}

customElements.define('maps-icon', MapsIcon);
